import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { Document } from 'react-pdf/dist/esm/entry.vite';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';
import { pxToRem } from 'Styles/utils/utils';

export const Iframe = styled.iframe`
  width: 100%;
  min-height: 100%;
  #annotationContainer {
    overflow: 'auto';
    -webkit-overflow-scrolling: 'touch';
  }
`;

export const Container = styled.div`
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  width: 70%;
  margin: 0 auto;
  height: 600px;
  canvas {
    margin: 0 auto;
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
    height: 100%;
    canvas {
      width: 100% !important;
      height: auto !important;
    }
  }
`;

export const ButtonActions = styled(FlexContainer)`
  margin-top: auto;
  > div:first-child {
    margin-right: ${pxToRem(20)};
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: auto;
    height: 25%;
    > div:first-child {
      margin-right: 0;
      margin-bottom: ${pxToRem(20)};
    }
  }
`;

export const DocumentContainer = styled(Document)`
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: block;
    width: 100%;
    height: 70%;
    overflow: auto;
  }
`;

export const Embed = styled.embed`
  width: 100%;
  min-height: 100%;
`;

export const DownloadLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 270px;
  height: 40px;
  font-size: 14px;
  padding: 5px 14px;
  font-weight: bold;
  border-radius: 36px;
  background-color: ${({ theme: { colors } }) => colors.white};
  color: ${({ theme: { colors } }) => colors.dark_500};
  border: 2px solid ${({ theme: { colors } }) => colors.dark_500};
  margin-bottom: ${({ theme: { sizing } }) => sizing.fds_size_16};
`;
